import React, { useState, useEffect } from 'react';
import { useMode } from '../contexts/ModeContext';

function LiveWorkRedirectNotice({ onDismiss }) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    // Auto-dismiss after 8 seconds
    const timer = setTimeout(() => {
      setVisible(false);
      onDismiss?.();
    }, 8000);

    return () => clearTimeout(timer);
  }, [onDismiss]);

  if (!visible) return null;

  return (
    <div className="live-work-notice" data-testid="live-work-notice">
      <div className="live-work-notice-content">
        <span className="live-work-icon">⚠️</span>
        <div className="live-work-text">
          <strong>Live-work context detected.</strong>
          <p>Training Mode is not authorized for live work. Redirecting to Reference Mode.</p>
        </div>
        <button 
          className="live-work-dismiss"
          onClick={() => {
            setVisible(false);
            onDismiss?.();
          }}
        >
          ✕
        </button>
      </div>
    </div>
  );
}

export default LiveWorkRedirectNotice;
